// A referral code from a shared link (?ref=CODE), kept so it can prefill sign-up
// and checkout later in the visit or on a return visit.
const KEY = 'learnable_ref';
const CODE_RE = /^[A-Za-z0-9_-]{2,60}$/;

export function captureRefFromUrl(search) {
  try {
    const code = new URLSearchParams(search).get('ref');
    if (code && CODE_RE.test(code)) localStorage.setItem(KEY, code.toUpperCase());
  } catch {}
}

export function getStoredRef() {
  try { return localStorage.getItem(KEY) || ''; } catch { return ''; }
}

export function clearStoredRef() {
  try { localStorage.removeItem(KEY); } catch {}
}
